import { PageMetaFromApi } from '@types';
import { formatContent, formatThumbnail } from '../commonFormatting';

export const formatPageMeta = (pageMeta: PageMetaFromApi[]) => pageMeta.map(meta => ({
  ...meta,
  thumbnail: formatThumbnail(meta.thumbnail),
  content: formatContent(meta.content),
}));
